import type { Bordereau } from '@mairistem/comptabilite';
import { isEmpty } from 'lodash';
import ActionResultType from '../../../interfaces/pieces/ActionResultType';
import BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import type { BaseLiquidationOptions } from '../../../interfaces/pieces/mouvements/liquidation/BaseLiquidationOptions';
import type { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import type TreeviewActionResult from '../../../interfaces/pieces/TreeviewActionResult';
import { updateBordereauEtat } from '../../../services/piecesComptables/bordereaux/bordereaux';
import BaseLiquidationAction from '../../pieces/BaseLiquidationAction';

class BordereauActualiseEtatAction extends BaseLiquidationAction<
	BordereauWithState,
	BordereauActionType
> {
	constructor(options: BaseLiquidationOptions = null) {
		super(options);
		this.label = 'Actualiser le statut du bordereau';
		this.type = BordereauActionType.ACTUALISER_ETAT;
		this.isShown = (bordereau) =>
			!isEmpty(bordereau.iddX2) && !isEmpty(bordereau.identifiantBordPastell);
	}

	execute = (
		bordereau: BordereauWithState,
	): TreeviewActionResult<Bordereau> => ({
		result: updateBordereauEtat(
			bordereau?.identifiant as number,
			new URLSearchParams({
				withJournaux: 'true',
			}),
		),
		type: ActionResultType.UPDATE,
	});
}

export default BordereauActualiseEtatAction;
